import { render } from "./Footer.vue?vue&type=template&id=2a72d595"
const script = {}

import exportComponent from "C:\\laragon\\www\\agrifutura\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/frontend/components/Footer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2a72d595"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2a72d595', __exports__)) {
    console.log('reload')
    api.reload('2a72d595', __exports__)
  }
  
  module.hot.accept("./Footer.vue?vue&type=template&id=2a72d595", () => {
    console.log('re-render')
    api.rerender('2a72d595', render)
  })

}


export default __exports__